import { Group, Stack } from "@mantine/core"
import { useContext } from "react"

import { OpChainList } from "~/pages/Admin/Ingestion/OpChains/components/OpChainList/OpChainList"
import { OpChainManagementContainer } from "~/pages/Admin/Ingestion/OpChains/components/OpChainManagementContainer/OpChainManagementContainer"
import { OperationChainType } from "~/pages/Admin/Ingestion/OpChains/hooks/useCreateOpChainMutation"
import { OpChainContext } from "~/pages/Admin/Ingestion/OpChains/store/op-chain-context"

export function OpChains() {
  const { operationChains: opChains } = useContext(OpChainContext)

  const productOpChains = opChains.filter(
    (opChain) => opChain.type === "PRODUCT"
  )
  const componentOpChains = opChains.filter(
    (opChain) => opChain.type === "COMPONENT"
  )
  const materialOpChains = opChains.filter(
    (opChain) => opChain.type === "MATERIAL"
  )

  return (
    <Stack>
      <Group
        py="var(--tfg-organism-padding-y)"
        px="var(--tfg-organism-padding-x)"
      >
        <OpChainList
          operationChainType={OperationChainType.PRODUCT}
          opChains={productOpChains}
        />
        <OpChainList
          operationChainType={OperationChainType.COMPONENT}
          opChains={componentOpChains}
        />
        <OpChainList
          operationChainType={OperationChainType.MATERIAL}
          opChains={materialOpChains}
        />
      </Group>
      <OpChainManagementContainer />
    </Stack>
  )
}
